//export const API_BASE_URL = 'http://192.168.29.193:3008';
export const API_BASE_URL = 'https://rib.sriyansh.com';




//#012f30ff"

export const Menu_Back_Color="#020adfff"
export const Menu_Text_Color="#fff"
export const Menu_List_Text_Color="#fff"
export const Menu_Open_Drawer_Color="#f70909ff"
export const Menu_Close_Drawer_Color="#fff"
export const Menu_Hover_Color="#3445ff"
export const Left_Icon_Color='#ffea00'

export const Heading_Text_Color="#df16c8ff"
export const Heading_Background_Color="#030acbff"   

export const Credit_Heading_Text_Color="red"
export const Credit_Table_Heading_Background_Color="red" 


export const Debit_Heading_Text_Color="green"
export const Debit_Table_Heading_Background_Color="green"

export const Table_Heading_Text_Color="white"

